import { MapfreIconComponent } from '../../mapfre-icon/mapfre-icon.component';
import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit , NO_ERRORS_SCHEMA } from "@angular/core";
import { AcmicService } from "./../../../../_services/acmic.service";

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbRippleModule, MapfreIconComponent],
  selector: "mapfre-button",
  templateUrl: "./mapfre-button.component.html"
})
export class MapfreButtonComponent implements OnInit {
  @Input() additionalClasses = "basic primary";
  @Input() form: any;
  @Input() customIcon: string;
  @Input() buttonCopy: string;
  @Input() backIcon: string;
  @Input() disabledValue = true;
  @Input() howManyIconsUsed: number;
  @Input() iconClasses = "";
  @Input() iconFamily: string;
  @Input() inputType: string;
  @Input() loading = false;
  @Input() modalId: string;
  @Input() modalFunctionId: string;
  @Input() screenReader = false;
  @Input() showIcons = false;
  @Input() showIconsCustom = false;
  @Input() translateValue: string;
  @Input() showUserName: string;
  @Input() btnId:string;
  iconClassesArray: string[] = [this.iconClasses];
  stateCode: string;
  constructor(private acmicService: AcmicService) {}

  public moreCSSClasses(classes: string): boolean {
    return classes != undefined ? true : false;
  }

  isFormValid(): boolean {
    return this.disabledValue == undefined ? true : this.disabledValue;
  }

  checkIconClasses(icons: string): void {
    if (this.howManyIconsUsed == 2) {
      this.iconClassesArray = icons.split(",");
    }
  }

  ngOnInit(): void {
    this.stateCode = this.acmicService.isACMIC() ? "ACMIC" : "MA";    
    this.iconClassesArray[0] = this.iconClasses;
    this.checkIconClasses(this.iconClasses);
  }
}
